import Table, { ColumnsType } from "antd/es/table";
import { localizeDateTime } from "../../utils";
import { Button, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../redux/hooks";

const ConnectLogTabel = (props: any) => {
  const { data, title, onUpdateCallLogModal, msil } = props;
  const auth = useAppSelector<any>((store) => store.auth);
  const user = auth.user;

  const isSuperUser = user?.roles?.some((role: { role_type: string }) =>
    ["super_user"].includes(role.role_type)
  );


  const columns: ColumnsType<any> = [
    {
      title: "Log type",
      dataIndex: "log_type",
      key: "log_type"
    },
    ...(msil
      ? [
          {
            title: "MSIL Site Readiness Status",
            dataIndex: "msil_site_readiness_status",
            key: "msil_site_readiness_status"
          }
        ]
      : []),
    {
      title: "Summary",
      dataIndex: "summary",
      key: "summary"
    },
    {
      title: "Is call connected",
      dataIndex: "call_connected",
      key: "call_connected",
      render: (call_connected: any) => {
        return call_connected ? "YES" : "NO";
      }
    },
    {
      title: "Next follow up at",
      dataIndex: "next_follow_up_at",
      key: "next_follow_up_at",
      render: (next_follow_up_at) => (
        <>{next_follow_up_at ? localizeDateTime(next_follow_up_at) : "-"}</>
      )
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <>{created_at ? localizeDateTime(created_at) : "-"}</>
    },
    {
      title: "Created by",
      dataIndex: "user",
      key: "user",
      render: (user: any) => {
        return `${user?.name} - ${user?.mobile}`;
      }
    }
  ];


  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_: any, call_log: any) => (
      <>
        <Button
          icon={<EditOutlined />}
          onClick={() => onUpdateCallLogModal(call_log)}
          title="Update"
        ></Button>
      </>
    )
  };

  if (isSuperUser) {
    columns.push(actionColumn);
  }

  return (
    <div style={{ marginTop: 50 }}>
      <h2>{title}</h2>
      <Table
        rowKey="id"
        bordered
        columns={columns}
        pagination={false}
        dataSource={data}
        scroll={{ x: 400 }}
      />
    </div>
  );
};

export default ConnectLogTabel;
